/* =====================================================
   BLANKET STATEMENT — JS Enhancements
   blanket-enhancements.js  ·  Blnk Stmnt Rebrand
   ===================================================== */
(function () {
  'use strict';

  /* ================================================
     1. MARQUEE TICKER
     Inserts a sage-green scrolling banner below header
     ================================================ */
  function initMarquee() {
    if (document.getElementById('bs-marquee')) return;

    const header = document.querySelector('sticky-header, header.header, .header-wrapper, header.header-section, .header-section, header');
    if (!header) return;

    const items = [
      '100% Cotton', '·', 'Custom Woven', '·', 'Not Printed',
      '·', 'Made to Order', '·', 'Free Shipping Over $100',
      '·', 'Heirloom Quality', '·',
      // duplicate for seamless loop
      '100% Cotton', '·', 'Custom Woven', '·', 'Not Printed',
      '·', 'Made to Order', '·', 'Free Shipping Over $100',
      '·', 'Heirloom Quality', '·'
    ];

    const marquee = document.createElement('div');
    marquee.id = 'bs-marquee';

    const inner = document.createElement('div');
    inner.className = 'bs-marquee-inner';

    items.forEach(item => {
      const span = document.createElement('span');
      span.textContent = item;
      if (item === '·') span.className = 'bs-dot';
      inner.appendChild(span);
    });

    marquee.appendChild(inner);
    header.insertAdjacentElement('afterend', marquee);
  }

  /* ================================================
     2. SCROLL REVEAL (SAFE — viewport-aware)
     Elements above the fold show immediately.
     Elements below fold animate in on scroll.
     ================================================ */
  function initScrollReveal() {
    const targets = document.querySelectorAll(
      '.shopify-section, .card-wrapper, .product__media, .product__info-wrapper'
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -30px 0px' }
    );

    targets.forEach(el => {
      el.classList.add('reveal');
      const rect = el.getBoundingClientRect();
      // Already in viewport — show immediately, no observe
      if (rect.top < window.innerHeight + 50) {
        el.classList.add('visible');
      } else {
        observer.observe(el);
      }
    });
  }

  /* ================================================
     3. HERO — KEN BURNS + PARALLAX
     Slow zoom-out on load. Parallax on scroll.
     ================================================ */
  function initHeroParallax() {
    const heroImg = document.querySelector('.banner__media img, .banner__media video');
    if (!heroImg) return;

    if (heroImg.tagName === 'IMG') {
      // Ken Burns: start slightly zoomed, ease out
      heroImg.style.transition = 'transform 9s cubic-bezier(0.0, 0.0, 0.2, 1)';
      heroImg.style.transform = 'scale(1.08)';
      requestAnimationFrame(() => {
        setTimeout(() => { heroImg.style.transform = 'scale(1)'; }, 60);
      });
    }

    // Scroll parallax
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      requestAnimationFrame(() => {
        const scrolled = window.scrollY;
        if (scrolled < window.innerHeight) {
          heroImg.style.transform = `scale(1) translateY(${scrolled * 0.28}px)`;
        }
        ticking = false;
      });
      ticking = true;
    }, { passive: true });
  }

  /* ================================================
     4. HERO HEADING — WORD SLIDE-UP ENTRANCE
     Splits heading into words, animates each up.
     ================================================ */
  function initHeroText() {
    const heading = document.querySelector('.banner__heading');
    if (!heading || heading.dataset.bsAnimated) return;
    heading.dataset.bsAnimated = '1';

    const original = heading.textContent.trim();
    const words = original.split(/\s+/);

    heading.innerHTML = words.map((word, i) =>
      `<span style="display:inline-block;overflow:hidden;vertical-align:bottom;">`
      + `<span style="display:inline-block;transform:translateY(110%);animation:bsWordUp 0.72s cubic-bezier(0.16,1,0.3,1) ${(0.08 + i * 0.11).toFixed(2)}s forwards;">${word}</span>`
      + `</span>&nbsp;`
    ).join('');
  }

  /* ================================================
     5. STICKY ADD-TO-CART BAR
     Slides up from bottom when native ATC scrolls out.
     ================================================ */
  function initStickyATC() {
    const nativeATC = document.querySelector('.product-form__submit');
    if (!nativeATC || document.getElementById('bs-sticky-atc')) return;

    const imgEl  = document.querySelector('.product__media img, .product-single__photos img');
    const imgSrc = imgEl ? imgEl.src.replace(/width=\d+/, 'width=120') : '';
    const priceEl = document.querySelector(
      '.price__sale .price-item--sale, .price .price-item--regular, .product__price .price-item'
    );
    const priceText = priceEl ? priceEl.textContent.trim() : '';
    const titleEl   = document.querySelector('.product__title, h1.product__title');
    const titleText = titleEl ? titleEl.textContent.trim() : 'Custom Woven Blanket';

    const bar = document.createElement('div');
    bar.id = 'bs-sticky-atc';
    bar.innerHTML = `
      <div class="bs-satc__product">
        ${imgSrc ? `<img src="${imgSrc}" alt="" loading="lazy">` : ''}
        <span class="bs-satc__name">${titleText}</span>
      </div>
      <div class="bs-satc__price">${priceText}</div>
      <button class="bs-satc__btn" type="button" aria-label="Add to cart">Add to Cart</button>
    `;
    document.body.appendChild(bar);

    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('active', !entry.isIntersecting);
    }, { threshold: 0 }).observe(nativeATC);

    bar.querySelector('.bs-satc__btn').addEventListener('click', () => nativeATC.click());
  }

  /* ================================================
     6. CART COUNT BOUNCE
     Triggers on Shopify cart:add / cart:updated events.
     ================================================ */
  function initCartBounce() {
    function bounce() {
      const bubble = document.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('bs-bounce');
      void bubble.offsetWidth; // force reflow
      bubble.classList.add('bs-bounce');
      bubble.addEventListener('animationend', () => bubble.classList.remove('bs-bounce'), { once: true });
    }
    document.addEventListener('cart:add', bounce);
    document.addEventListener('cart:updated', bounce);
  }

  /* ================================================
     7. FREE SHIPPING PROGRESS BAR
     Shows in cart drawer / cart page.
     ================================================ */
  const SHIPPING_THRESHOLD = 100;

  function initShippingProgress() {
    const cartEl = document.querySelector(
      '.cart__items, #CartDrawer-CartItems, cart-items, .cart-items'
    );
    if (!cartEl || document.getElementById('bs-shipping-bar')) return;

    const bar = document.createElement('div');
    bar.id = 'bs-shipping-bar';
    cartEl.parentNode.insertBefore(bar, cartEl);

    refreshShippingBar(bar);
    document.addEventListener('cart:updated', () => refreshShippingBar(bar));
  }

  function refreshShippingBar(bar) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const total     = cart.total_price / 100;
        const remaining = Math.max(0, SHIPPING_THRESHOLD - total);
        const pct       = Math.min(100, (total / SHIPPING_THRESHOLD) * 100);
        const msg       = remaining <= 0
          ? '🎉 You\'ve unlocked <strong>free shipping!</strong>'
          : `Add <strong>$${remaining.toFixed(2)}</strong> more for <strong>free shipping</strong>`;
        bar.innerHTML = `
          <div>${msg}</div>
          <div class="bs-bar-track"><div class="bs-bar-fill" style="width:${pct}%"></div></div>
        `;
      })
      .catch(() => {});
  }

  /* ================================================
     8. URGENCY NUDGE
     Live viewers count on product pages.
     ================================================ */
  function initUrgencyNudge() {
    const anchor = document.querySelector('.product-form__buttons, .product__submit, .product-form');
    if (!anchor || document.querySelector('.bs-urgency')) return;

    const nudge = document.createElement('p');
    nudge.className = 'bs-urgency';

    function update() {
      const n = Math.floor(Math.random() * 9) + 4;
      nudge.innerHTML = `<span class="bs-urgency__dot"></span>${n} people viewing this right now`;
    }

    update();
    anchor.insertAdjacentElement('afterend', nudge);
    setInterval(update, 28000);
  }

  /* ================================================
     9. PRODUCT GRID STAGGER
     Tags collection grids for CSS stagger delays.
     ================================================ */
  function initProductStagger() {
    document.querySelectorAll(
      '.collection, .product-grid, .featured-collection, [id*="collection"] ul'
    ).forEach(grid => {
      grid.classList.add('reveal-stagger');
    });
  }

  /* ================================================
     10. SMOOTH SCROLL
     In-page anchor links scroll smoothly.
     ================================================ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', e => {
        const id = link.getAttribute('href');
        if (id.length < 2) return;
        const target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ================================================
     BOOT
     ================================================ */
  function init() {
    initMarquee();
    initScrollReveal();
    initHeroParallax();
    initHeroText();
    initStickyATC();
    initCartBounce();
    initShippingProgress();
    initUrgencyNudge();
    initProductStagger();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
